export class FounderSection extends HTMLElement {
    connectedCallback() {
      this.infosVideos       = this.querySelectorAll('.founder-section__video');

      this._initVideos();

    }

    /**
     * INIT VIDEO FROM IFRAME
     */
    _initVideos() {
      this.infosVideos.forEach(function(value, index) {
        value.setAttribute('src', value.getAttribute('data-src'));
      });
    }
  
}

try {
  window.customElements.define('founder-section', FounderSection);
} catch(e) {}